import { render, staticRenderFns } from "./DropdownType.vue?vue&type=template&id=01855540&"
import script from "./DropdownType.vue?vue&type=script&lang=js&"
export * from "./DropdownType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01855540')) {
      api.createRecord('01855540', component.options)
    } else {
      api.reload('01855540', component.options)
    }
    module.hot.accept("./DropdownType.vue?vue&type=template&id=01855540&", function () {
      api.rerender('01855540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/DropdownType.vue"
export default component.exports